export default __webpack_public_path__ + "static/media/en-logo.a259f28c.svg";